/** Map supporting screens to the accounting area that owns them. */
export function accountingNavigationArea(path: string): string {
  const root = `/${path.split("/").filter(Boolean)[0] ?? ""}`
  if (root === "/" || root === "/dashboard") return "/dashboard"
  if (root === "/dashboards") return "/dashboards"
  if (root === "/books") return "/books"
  if (["/billing", "/payments"].includes(root)) return "/billing"
  if (root === "/files" || (root === "/companies" && path.split("/")[3] === "files")) return "/files"
  if (root === "/projects" && path.split("/")[3] === "files") return "/files"
  if (root === "/financial-reports") return "/books"
  if (root === "/approvals") return "/approvals"
  if (root === "/personnel") return "/personnel"
  if (["/reports", "/report-templates"].includes(root) ||
    (["/companies", "/projects"].includes(root) && path.split("/")[3] === "reports")) return "/reports"
  if (["/agent-work", "/chats", "/workflows", "/server"].includes(root)) return "/agent-work"
  if (root === "/admin") return path
  if (root === "/companies" && path.split("/")[3] === "employees") return "/personnel"
  return "/settings"
}
